@if (criticalError) {
  <div id="critical-error" class="pap-mat-primary">
    <div class="error-message">
      <strong>Critical Error occurred</strong>
    </div>
    <img [src]="errorUrl" style="height: 400px;">
    <div>
      <strong>{{ criticalError.name }}:</strong> {{ criticalError.message }}
    </div>
  </div>
}
